<template>
  <div class="quizzes">
    <div v-if="!showQuizForm" class="quiz-list__wrapper">
      <ul class="swap" v-sortable="{onEnd: reorder}">
        <li v-for="quiz in tag.meta.quizzes" :key="quiz.id" class="quiz-list__item _flxrcs">
          <span class="quiz-list__item-label">
          {{quiz.question.lang ? quiz.question[quiz.question.lang].length > 30 ? quiz.question[quiz.question.lang].substr(0, 30) + '...' : quiz.question[quiz.question.lang] : ''}}
          </span>
          <i title="Edit quiz" @click="onQuizEdit(quiz)" class="quiz-list__item-edit-icon material-icons">
            create
          </i>
          <i title="Delete quiz" @click="onQuizRemove(quiz.id)" class="quiz-list__item-delete-icon material-icons">
            delete
          </i>
        </li>
      </ul>
      <button title="Add quiz" @click="onQuizCreate" class="action-button"><i class="material-icons">add</i></button>
    </div>
    <QuizForm v-if="showQuizForm" :tag="tag" v-bind:key="tag && tag.id" @close="showQuizForm=false" @save="showQuizForm=false"></QuizForm>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import QuizForm from './quizForm'
import * as Sortable from 'sortablejs/Sortable.js'

export default {
  name: 'quizzes',
  props: ['tag'],
  components: {
    QuizForm
  },
  directives: {
    sortable: {
      inserted(el, binding) {
        Sortable.create(el, binding.value)
      }
    }
  },
  data() {
    return {
      showQuizForm: false
    }
  },
  methods: {
    ...mapMutations(['removeQuizFromQuizzes', 'saveQuizzes', 'setQuiz']),
    onQuizCreate() {
      this.tag.meta.quiz = null
      this.showQuizForm = true
    },
    onQuizEdit(quiz) {
      this.setQuiz(quiz)
      this.showQuizForm = true
    },
    onQuizRemove(id) {
      this.removeQuizFromQuizzes(id)
    },
    reorder({ oldIndex, newIndex }) {
      const movedItem = this.tag.meta.quizzes.splice(oldIndex, 1)[0]
      this.tag.meta.quizzes.splice(newIndex, 0, movedItem)
      this.saveQuizzes(this.tag.meta.quizzes)
    }
  },
  beforeDestroy() {
    this.tag.meta.quiz = null
  },
  mounted() {
    if (!this.tag.meta.quizzes) {
      this.tag.meta.quiz = null
      this.showQuizForm = true
    }

    if (this.tag.meta.quizzes) {
      this.tag.meta.quizzes = this.tag.meta.quizzes
    } else {
      this.$set(this.tag.meta, 'quizzes', [])
    }
  }
}
</script>